const BASE_REWARD_LAST_TOURNAMENT_REDUCER: string = 'REWARD_LAST_TOURNAMENT';
export const REWARD_LAST_TOURNAMENT_LOADING: string = `${BASE_REWARD_LAST_TOURNAMENT_REDUCER}_LOADING`;
export const REWARD_LAST_TOURNAMENT_ERROR: string = `${BASE_REWARD_LAST_TOURNAMENT_REDUCER}_ERROR`;
export const REWARD_LAST_TOURNAMENT_SUCCESS: string = `${BASE_REWARD_LAST_TOURNAMENT_REDUCER}_SUCCESS`;
